
import moment from 'moment';
import IDKITApi from '../libs/IDKITApi';
import createAuthApiRepository from '../modules/auth/infrastructure/AuthApiRepository';
import login from '../modules/auth/application/login';
import orderDetail from '../libs/mixins/orderDetail';
import saveLoginData from '../libs/utils/authUtils';

export default {
  mixins: [orderDetail],

  data: () => ({
    errorMessage: '',
    isErrorLogin: false,
    errorMessageLogin: '',
    showError: false,
    orderId: '',
    token: '',
    brand: '',
    email: '',
    emailIdKit: '',
    orderStatus: null,
    showNoticePrivacy: false,
    showTutorial: 0,
    emailInvalid: false,
    notFoundOrders: false,
    initialStep: 0,
    persistent: true,
    lastSuperOrderId: null,
  }),

  mounted() {
    this.start();
    this.lastSuperOrderId = localStorage.getItem('superOrderId') ? localStorage.getItem('superOrderId') : this.$session.get('superOrderId');
  },

  methods: {
    async start() {
      const loaderText = this.$session.get('token') ? 'Validando sesión' : 'Iniciando sesión';
      this.loaderShow(loaderText);
      // Tomamos el email y el state inyectado por IDKIT
      this.email = this.$route.query.email;
      const { state } = this.$route.query;
      this.token = this.$route.query.token;
      this.brand = this.$route.query.brand;
      if (process.env.NODE_ENV !== 'production') this.orderId = localStorage.getItem('superOrderId') ? localStorage.getItem('superOrderId') : this.$session.get('superOrderId');
      else {
        this.orderId = localStorage.getItem('superOrderId') ? localStorage.getItem('superOrderId') : this.$session.get('superOrderId');
      }
      const orderIdUrl = this.$route.query.orderId
        ? this.$route.query.orderId : this.$route.query.orderid;
      if (!this.orderId) this.orderId = orderIdUrl;

      if (process.env.NODE_ENV !== 'production') this.orderStatus = this.$route.query.orderStatus;

      try {
        await this.startIDKitSession(state);
        await this.login();
      } catch (error) {
        this.showError = true;
      } finally {
        this.loaderHide();
      }
    },

    startIDKitSession(state) {
      return this.getIDKitSessionData(state);
    },

    getIDKitSessionData(state) {
      return IDKITApi.getIDKitSessionData(state)
        .then((data) => {
          this.emailIdKit = data.emailClient;
          this.$session.start(21600000);
          this.$session.set('email', data.emailClient);
          this.$session.set('state', state);
          this.$session.set('token', data.access_token);
          localStorage.setItem('token', data.access_token);
          this.$session.set('expire_date', moment().add(data.expires_in, 'seconds').format('YYYY-MM-DD HH:mm'));

          return data.emailClient;
        })
        .catch((error) => {
          throw this.validateResponseErrorMessage(error);
        });
    },

    async login() {
      try {
        const repository = createAuthApiRepository();

        const data = await login(repository, {
          email: this.email,
          orderHigherIdExt: this.orderId,
        });

        if (this.emailIdKit !== data.customerEmail) {
          this.emailInvalid = true;
          throw new Error('Email inválido');
        }

        const { showTutorial, showNoticePrivacy } = saveLoginData(this.$session, data, this.email);

        this.showTutorial = showTutorial;
        this.showNoticePrivacy = showNoticePrivacy;

        await this.getOrderDetail(true, this.orderStatus);
      } catch (error) {
        this.error = error;
      } finally {
        this.loaderHide();
      }
    },

    async logout() {
      this.loaderShow('Cerrando sesión');

      try {
        if (process.env.NODE_ENV === 'production') await IDKITApi.logout(this.$session.get('state'));

        this.$session.clear();

        this.$router.push({
          name: 'loginClient',
          query: { orderId: this.orderId },
        });
      } catch (error) {
        this.alertShow(error, 'error');
      } finally {
        this.loaderHide();
      }
    },

    getIDKitDevData() {
      return new Promise((accept) => {
        accept({
          username: 'development',
          firstname: 'John',
          lastname: 'Doe',
          roleId: 1,
          role: 'Client user',
        });
      });
    },
  },
};
